import ImageSourceModel from '../../models/IDaq/ImageSourceModel';
import BaseStore from '../BaseStore';
import {observable} from "mobx/lib/mobx";

class ImageSourceStore extends BaseStore {

  protocolOptions = [
    {name: 'Disabled', id: -1},
    {name: 'FTP', id: 1},
    {name: 'SFTP', id: 2},
    {name: 'File System', id: 3},
    {name: 'Manual Upload', id: 4}
  ];

  @observable albums = [];

  constructor(transportLayer) {
    super(ImageSourceModel, transportLayer);
  }

  fetchAlbums(){
    return this.transportLayer.album.fetchAll().then(res => {
      this.albums = res;
    });
  }

}

export default ImageSourceStore;


// WEBPACK FOOTER //
// ./src/stores/IDaq/ImageSourceStore.js